import { useMemo } from 'react';
import { Markets, OddsMarketScope, OddsMarketTypes } from '../../../../packages/types';

const useReconcileScopeMarkets = (
  market?: Markets,
): {
  oddsMarket?: Markets;
  oddsMarketScope?: OddsMarketScope;
} => {
  return useMemo(() => {
    if (market === OddsMarketTypes.FIRST_HALF || market === OddsMarketTypes.SECOND_HALF || market === OddsMarketTypes.FULL_TIME) {
      return {
        oddsMarket: OddsMarketTypes.ONEXTWO,
        oddsMarketScope: market,
      };
    }

    return {
      oddsMarket: market,
    };
  }, [market]);
};

export default useReconcileScopeMarkets;
